import { getIvrBaseResource } from 'src/actions/ivrs/ivrResource';

const threadResource = getIvrBaseResource('v1/orgs/:orgId/consumer-self-service/ivrs/:id/versions/:version', 'thread');

export default threadResource;
